<div class="company-form" *ngIf="companyId">
    <h2>{{ "addLeadFormTitle" | translate }}</h2>

    <form nz-form [formGroup]="addLeadForm" class="lead-form" (ngSubmit)="submitForm()">
        <nz-alert class="m-b-10" nzType="error" nzDescription="{{'invalidCaptchaErr' | translate}}" nzShowIcon *ngIf="invalidCaptcha"></nz-alert>

        <nz-alert class="m-b-10" nzType="success" nzMessage="{{'leadAddSuccess' | translate}}" nzShowIcon *ngIf="addLeadSuccess"></nz-alert>

        <nz-form-item>
            <nz-form-control nzErrorTip="{{'leadFirstNameError' | translate}}">
                <input type="text" nz-input formControlName="first_name" placeholder="{{'leadInputFirstName' | translate}}" id="firstName">
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-control nzErrorTip="{{'leadLastNameError' | translate}}">
                <input type="text" nz-input formControlName="last_name" placeholder="{{'leadInputLastName' | translate}}" id="lastName">
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-control nzErrorTip="{{'leadEmailError' | translate}}">
                <input type="email" nz-input formControlName="email" placeholder="{{'leadInputEmail' | translate}}" id="email">
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-control nzErrorTip="{{'leadMobileError' | translate}}">
                <input type="number" nz-input formControlName="mobile_number" placeholder="{{'leadInputPhoneNumber' | translate}}" id="phoneNumber">
            </nz-form-control>
        </nz-form-item>

        <div>
            <div #recaptcha class="m-b-10  re-captcha">Loading Captcha...</div>

            <nz-form-item>
                <nz-form-control>
                    <div class="text-center">
                        <button nz-button class="is-login-btn" [nzDisabled]="isFormSaving" [nzLoading]="isFormSaving" [nzType]="'primary'">
                            {{"leadSubmit" | translate}}
                        </button>
                    </div>
                </nz-form-control>
            </nz-form-item>
        </div>
    </form>
    <div class="create-meeting-dialog"  *ngIf="showCreateMeetingDialog">
      <nz-modal
        [(nzVisible)]="isVisible"
        [nzTitle]="modalTitle"
        [nzFooter]="modalFooter"
        (nzOnCancel)="handleCancel()"
        [nzOkLoading]="isOkLoading"
        >
        <ng-template #modalTitle>{{ "addLeadMeetingFormTitle" | translate }}</ng-template>
        <div *ngIf="!lmSession" class="popup-content">
          <form nz-form [formGroup]="addLeadMeetingForm" class="lead-meeting-form">
            <nz-form-item>
              <nz-form-label>{{'TimeZone' | translate}}</nz-form-label>
              <nz-form-control>
                <input nz-input disabled="true" [value]="timeZoneValue"/>
              </nz-form-control>
            </nz-form-item>
              <nz-form-item>
                <nz-form-label nzFor="date" nzRequired>{{'ScheduleSession'| translate}}</nz-form-label>
                <nz-form-control nzErrorTip="{{'*'| translate}}">
                  <nz-date-picker formControlName="date" nzFormat="dd/MM/yyyy"
                  defaultValue="today" placeholder="{{'ScheduleSession' | translate}}"
                  [nzDisabledDate]="disabledDate"
                  style="width: 100%;"
                  (ngModelChange)="sheduleDateChanged($event)"
                  nzPlaceHolder="{{'ScheduleSession'| translate}}">
                  </nz-date-picker>
                </nz-form-control>
              </nz-form-item>

              <nz-form-item *ngIf="disabledHoursCount<24 && disabledMinutesCount<60">
                <nz-form-label nzFor="start_time" nzRequired>{{'StartTime'| translate}}</nz-form-label>
                <nz-form-control nzErrorTip="{{'*'| translate}}">
                  <nz-time-picker formControlName="start_time" nzFormat="HH:mm" [nzDisabled]="!sessionObject.date"
                  [nzDisabledHours]= "disabledHours"
                  [nzDisabledMinutes]="disabledMinutes"
                  [nzMinuteStep]="15"
                  (ngModelChange)="startTimeChanged($event)" (nzInputReadOnly)=true
                  style="width: 100%;"
                  [nzHideDisabledOptions]="true"
                  nzPlaceHolder="{{'StartTime'| translate}}">
                  </nz-time-picker>
                </nz-form-control>
              </nz-form-item>
              <div class="row" *ngIf="disabledHoursCount==24 || disabledMinutesCount==60">
                <div class="col-md-12">
                  <span class="red-alert">{{'NoAvailableSlotForTheDateChosen'| translate}}</span>
                </div>
              </div>

              <nz-form-item>
                <nz-form-label nzFor="duration" nzRequired>{{'SessionDuration'| translate}}</nz-form-label>
                <nz-form-control nzErrorTip="{{'*'| translate}}">
                  <nz-select formControlName="duration"
                    nzPlaceHolder="{{'SessionDuration'| translate}}" class="w-100" (ngModelChange)="durationChanged($event)">
                    <nz-option *ngFor="let durationItem of freeSessionDurationList"
                    [nzLabel]="durationItem.text"
                    [nzValue]="durationItem.value">
                  </nz-option>
                </nz-select>
                </nz-form-control>
              </nz-form-item>

                  <nz-form-item>
                    <nz-form-label nzFor="description" nzRequired>{{'Description'| translate}}</nz-form-label>
                    <nz-form-control nzErrorTip="{{'*'| translate}}">
                      <textarea formControlName="description" nz-input rows="2" placeholder="{{'Description'| translate}}"></textarea>
                    </nz-form-control>
                  </nz-form-item>

              <nz-form-item style="display: none;">
                <nz-form-label nzFor="end_time" nzRequired>{{'EndTime'| translate}}</nz-form-label>
                <nz-form-control nzDisableAutoTips nzErrorTip="{{'*'| translate}}" >
                  <nz-time-picker nzDisabled nzInputReadOnly [nzDisabled]=true
                  formControlName="end_time" nzFormat="HH:mm"
                  [nzDefaultOpenValue]="defaultEndTimeOpenValue" nzAllowEmpty=false
                    nzPlaceHolder="{{'EndTime'| translate}}">
                  </nz-time-picker>
                </nz-form-control>
              </nz-form-item>
          </form>
        </div>
        <div *ngIf="lmSession" class="container">
          <div class="profile-setting-main">
            <div class="page-header" style="text-align: center;">
              <h2 class="font-weight-normal"> {{ 'SessionDetails' | translate }}</h2>
            </div>
            <div class="container">
              <nz-card>
                <div class="row">
                  <div class="col-md-12">
                    <span class="title">{{'TimeZone'| translate}}:</span>
                    <span class="info">{{timeZoneValue}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <span class="title">{{'SessionLink'| translate}}:</span>
                    <span class="info" #sessionLinkElem><a href="{{lmSession?.link}}">{{lmSession?.link}}</a></span>
                    <button nz-button nzType="default" nzShape="circle" (click)="copyToClipboardWithParameter(sessionLinkElem)">
                      <span nz-icon nzType="copy" nzTheme="fill"></span>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <span class="title">{{'Description'| translate}}:</span>
                    <span class="info">{{lmSession?.description}}</span>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <span class="title">{{'SessionInvitation'| translate}}:</span>
                    <button nz-button nzType="default" nzShape="circle" (click)="copyToClipboardWithParameter(userSessionInvitation)">
                      <span nz-icon nzType="copy" nzTheme="fill"></span>
                    </button>
                    <div class="invitation-info-conatiner" #userSessionInvitation>
                      <div class="invitation-info">{{lmSession?.owner_fullname}} {{'SessionInvitationInfo1' | translate}}</div>
                      <div class="invitation-info">{{'topic'| translate}}: {{lmSession?.name}}</div>
                      <div class="invitation-info">{{'SessionTime'| translate}}: {{lmSession?.date | date:'dd/MM/yyyy'}} {{lmSession?.start_time | date : 'h:mm:ss a'}}</div>
                      <div class="invitation-info">{{'SessionInvitationInfo2' | translate}}</div>
                      <div class="invitation-info"><a href="{{lmSession?.link}}">{{lmSession?.link}}</a></div>
                      <div class="invitation-info">{{'Description' | translate}}: {{lmSession?.description}}</div>
                    </div>
                  </div>
                </div>
                <div>
                </div>
              </nz-card>
          </div>
          </div>
        </div>
        <ng-template #modalFooter>
          <button nz-button nzType="default" class="cancel-btn" (click)="handleCancel()">{{ "cancel" | translate }}</button>
          <button nz-button *ngIf="!lmSession" class="submit-btn" (click)="handleOk()" [nzDisabled]="isMeetingFormSaving" [nzLoading]="isMeetingFormSaving" [nzType]="'primary'">
            {{"Submit" | translate}}
          </button>
          <nz-alert class="m-b-10" nzType="success" nzMessage="{{'leadMeetingAddedSuccess' | translate}}" nzShowIcon *ngIf="addLeadMeetingSuccess"></nz-alert>
        </ng-template>
      </nz-modal>
  </div>
</div>
